import styled from 'styled-components/macro'

import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { ContainerHeader } from 'components/container'
import { IconRfe } from 'components/icons/rfe'
import { motion } from 'framer-motion'

export const ObservedPoint = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 5rem;
`

export const StyledHeader = styled.header`
  width: 100%;
  padding-top: env(safe-area-inset-top);
  font-size: 1.6rem;
  z-index: 200;
  transition: all 0.4s;
  color: var(--text-color);

  > ${ContainerHeader} {
    position: relative;
    height: calc(var(--header-height) - env(safe-area-inset-top));

    > div {
      position: absolute;
      top: 0;
      right: var(--container-spacing);
      display: flex;
      align-items: center;
      margin-top: 1.3rem;

      ${mq.medium} {
        margin-top: 1.5rem;
      }
    }
  }
`

export const Logo = styled(IconRfe)`
  margin-top: 2.1rem;
  height: 2.9rem;
  width: auto;
  display: block;
  overflow: hidden;

  ${mq.medium} {
    height: 4.2rem;
  }
`

export const LogoContainer = styled(motion.a)`
  display: block;
  width: max-content;
  color: inherit;
  overflow: hidden;

  &:hover,
  &:focus {
    color: inherit;
  }
`
export const Home = styled(motion.div)<{ $active: boolean }>`
  padding: 0.9rem;
  height: 4rem;
  svg {
    width: 2rem;
  }
  ${props => (props.$active ? 'opacity: 0.3' : 'opacity: 1')}
`

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  right: var(--container-spacing);
  width: 1.9rem;
  height: var(--header-height);
  box-sizing: content-box;
  flex-shrink: 0;
  transition: 0.4s opacity 0.55s;
  z-index: 600;

  ${mq.medium} {
    width: auto;
  }
`

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid white;
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }

  ${mq.smallOnly} {
    button::before,
    button::after {
      border-top-color: ${theme.colors.accent.secondary};
    }
  }
`

export const Lang = styled(motion.ul)`
  list-style: none;
  font-weight: 800;
  overflow: hidden;
  white-space: nowrap;
  padding: 0;

  margin-right: 1.5rem;
  margin-left: 0.6rem;

  a {
    font-weight: normal;
    text-decoration: none;

    &:hover,
    &:focus-visible {
      text-decoration: underline;
    }
  }

  li {
    display: inline;

    &:not(:first-child)::before {
      content: ' | ';
      font-weight: normal;
    }
  }
`
